<div class="wsd-report role-tab admin">
    <form [formGroup]="reportRoleForm">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="p-grid">
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.ROLE_LABEL' | translate}}</label>
                        <p-multiSelect [options]="roleItems" maxSelectedLabels="2"
                            defaultLabel="{{ 'USER_REPORTS.ROLE_COUNT_TAB.ROLE_PLACEHOLDER' | translate }}"
                            formControlName="roles"
                            [class.placeholder]="!reportRoleForm.get('roles').value || reportRoleForm.get('roles').value.length === 0">
                        </p-multiSelect>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.REGION_LABEL' | translate}}</label>
                        <p-multiSelect [options]="regionItems" formControlName="regions" maxSelectedLabels="2"
                            defaultLabel="{{ 'USER_REPORTS.ROLE_COUNT_TAB.REGION_PLACEHOLDER' | translate }}"
                            [class.placeholder]="!reportRoleForm.get('regions').value || reportRoleForm.get('regions').value.length === 0">
                        </p-multiSelect>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.COUNTRY_LABEL' | translate}}</label>
                        <p-multiSelect [options]="countryItems" formControlName="countries" maxSelectedLabels="2"
                            defaultLabel="{{ 'USER_REPORTS.ROLE_COUNT_TAB.COUNTRY_PLACEHOLDER' | translate }}"
                            [class.placeholder]="!reportRoleForm.get('countries').value || reportRoleForm.get('countries').value.length === 0">
                        </p-multiSelect>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.ORGANIZATION_LABEL' | translate}}</label>
                        <p-multiSelect [options]="organizationItems" formControlName="organizations"
                            maxSelectedLabels="2"
                            defaultLabel="{{ 'USER_REPORTS.ROLE_COUNT_TAB.ORGANIZATION_PLACEHOLDER' | translate }}"
                            [class.placeholder]="!reportRoleForm.get('organizations').value || reportRoleForm.get('organizations').value.length === 0">
                        </p-multiSelect>
                    </div>
                </div>
            </div>
            <div class="ui-g-12 ">
                <div class="p-grid">
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.NAME_LABEL' | translate}}</label>
                        <wsd-extended-input [control]="reportRoleForm.get('name')">
                            <input pInputText formControlName="name" class="fs-13"
                                placeholder="{{ 'USER_REPORTS.ROLE_COUNT_TAB.NAME_PLACEHOLDER' | translate}}">
                        </wsd-extended-input>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.ROLE_COUNT_TAB.EMAIL_LABEL' | translate}}</label>
                        <wsd-extended-input [control]="reportRoleForm.get('email')">
                            <input pInputText formControlName="email" class="fs-13"
                                placeholder="{{ 'USER_REPORTS.ROLE_COUNT_TAB.EMAIL_PLACEHOLDER' | translate}}">
                        </wsd-extended-input>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.REG_FROM' | translate}}</label>
                        <wsd-extended-input [control]="reportRoleForm.get('dateFrom')">
                            <p-calendar wsdUseUtc [showIcon]="true" dateFormat="dd/mm/yy"
                                [maxDate]="reportRoleForm.get('dateTo').value" formControlName="dateFrom"
                                placeholder="{{ 'USER_REPORTS.ROLE_COUNT_TAB.SELECT_DATE_PLACEHOLDER' | translate }}"
                                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="dateRange">
                            </p-calendar>
                        </wsd-extended-input>
                    </div>
                    <div class="p-col-3">
                        <label>{{ 'USER_REPORTS.USER_COUNT_TAB.REG_TO' | translate}}</label>
                        <wsd-extended-input [control]="reportRoleForm.get('dateTo')">
                            <p-calendar wsdUseUtc [showIcon]="true" dateFormat="dd/mm/yy"
                                [minDate]="reportRoleForm.get('dateFrom').value" formControlName="dateTo"
                                [monthNavigator]="true" [yearNavigator]="true" [yearRange]="dateRange"
                                placeholder="{{ 'USER_REPORTS.ROLE_COUNT_TAB.SELECT_DATE_PLACEHOLDER' | translate }}">
                            </p-calendar>
                        </wsd-extended-input>
                    </div>
                </div>
            </div>
            <div class="ui-g-12 btns-row">
                <div class="p-grid">
                    <div class="p-col-3">
                        <div class="filter-row">
                            <button pButton class="ui-button-custom-primary inline-block width-full-parent w-70"
                                    [disabled]="searchDisabled"
                                label="{{ 'USER_REPORTS.ROLE_COUNT_TAB.SEARCH' | translate}} " (click)="searchUser()">
                            </button>
                            <button pButton class="ui-button-custom-secondary inline-block width-full-parent"
                                label="{{ 'USER_REPORTS.USER_COUNT_TAB.RESET' | translate}} " (click)="resetValue()">
                            </button>
                        </div>
                    </div>
                    <div class="p-col-3" [hidden]="exportEnabled()" >
                        <button type="button" pButton class="ui-button-custom-primary inline-block width-full-parent w-100"
                            label="{{ 'USER_REPORTS.ROLE_COUNT_TAB.EXPORT_RESULTS' | translate}}"
                            (click)="exportResult()">
                        </button>
                    </div>
                  <div class="p-col-3" [hidden]="!exportEnabled()" >
                    <button type="button" pButton class="ui-button-custom-secondary inline-block width-full-parent w-100"
                            label="{{ 'USER_REPORTS.ROLE_COUNT_TAB.EXPORT_RESULTS' | translate}}" [disabled]="exportEnabled()"
                            (click)="exportResult()">
                    </button>
                    <br/>
                    <span class="errorMessage">{{ 'USER_REPORTS.ERROR.BLOCKED_EXPORT' | translate }}</span>
                  </div>
                </div>
            </div>
            <div class="ui-g-12">
                <div class="p-grid table-header-labels ">
                    <label class="user-count-result fs-16">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE_HEADER_LABEL' |
                        translate}}</label>
                    <label class="user-count-result highlight fs-16">
                        {{ 'USER_REPORTS.ROLE_COUNT_TAB.USER_COUNT_RESULT' | translate:{count: users?.totalElements ||
                        0}
                        }}</label>
                </div>
            </div>
            <div class="ui-g-12">
                <div class="p-grid user-table-grid">
                    <wsd-user-list-grid [users]="users" (onPageChangeEvent)="onPageChangeEvent($event)" style="width: 100%"
                        [pageSize]="pageSize"></wsd-user-list-grid>
                </div>
            </div>
        </div>
    </form>
</div>
